/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type UpdateDashboardRequestBody = {
  /**
   * What the dashboard is for, at most 2000 characters
   */
  description?: string | undefined;
  /**
   * The dashboard to update
   */
  id: string;
  /**
   * Display name, at most 200 characters
   */
  name: string;
};

/** @internal */
export type UpdateDashboardRequestBody$Outbound = {
  description?: string | undefined;
  id: string;
  name: string;
};

/** @internal */
export const UpdateDashboardRequestBody$outboundSchema: z.ZodMiniType<
  UpdateDashboardRequestBody$Outbound,
  UpdateDashboardRequestBody
> = z.object({
  description: z.optional(z.string()),
  id: z.string(),
  name: z.string(),
});

export function updateDashboardRequestBodyToJSON(
  updateDashboardRequestBody: UpdateDashboardRequestBody,
): string {
  return JSON.stringify(
    UpdateDashboardRequestBody$outboundSchema.parse(updateDashboardRequestBody),
  );
}
